<template>
  <div class="input-controller-wrapper">
    <v-btn
      v-tooltip="saveTooltipSettings"
      small
      class="mx-3"
      :disabled="disableSave"
      @click="$emit('save')"
    >
      <StIcon
        icon-name="check"
      />
    </v-btn>
    <v-btn
      v-tooltip="cancelTooltipSettings"
      small
      @click="$emit('cancel')"
    >
      <StIcon
        icon-name="close"
      />
    </v-btn>
  </div>
</template>

<script>
import StIcon from '@stilingue/st-icon';

export default {
  name: 'InputController',
  components: {
    StIcon,
  },
  props: {
    disableSave: {
      type: Boolean,
      default: false,
    },
    placementTooltip: {
      type: String,
      default: 'top',
    },
  },
  data() {
    return {
      saveTooltip: 'Salvar',
      cancelTooltip: 'Cancelar',
    };
  },
  computed: {
    saveTooltipSettings() {
      const saveContent = {
        content: this.saveTooltip,
        placement: this.placementTooltip,
        targetClasses: ['it-has-a-tooltip'],
      };
      return saveContent;
    },
    cancelTooltipSettings() {
      const cancelContent = {
        content: this.cancelTooltip,
        placement: this.placementTooltip,
        targetClasses: ['it-has-a-tooltip'],
      };
      return cancelContent;
    },
  },
};
</script>

<style scoped lang="scss">
  .input-controller-wrapper {
    display: contents;
  }
</style>
